module.exports = "/assets/data/4b90dbadfaa917154f53cf46a1f1ecc7-CF36.data.json";